module.exports = __webpack_public_path__ + "img/filecoin.6a3bd7b3.png";